





















































import Vue, { PropType } from 'vue';
import { CourseraCategory, CourseraProgram } from '~/models/coursera';
import CourseraService from '~/services/CourseraService';
import CourseraCategories from './CourseraCategories.vue';
import CourseraSearch from './CourseraSearch.vue';

type Tab = 'catalog' | 'my-courses';

export default Vue.extend({
    name: 'CourseraHeader',
    components: {
        CourseraCategories,
        CourseraSearch,
    },
    props: {
        program: {
            type: Object as PropType<CourseraProgram>,
            required: true,
        },
        hasAccess: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            lightVersion: true,
            loading: true,

            categories: [] as CourseraCategory[],
        };
    },
    computed: {
        tab(): Tab {
            const myCourses = window.location.pathname.includes('coursera/my-courses');
            return myCourses ? 'my-courses' : 'catalog';
        },
        coverImage(): string {
            return (
                this.program.coverImage ||
                'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-university-assets.s3.amazonaws.com/a8/e102267c4a441f91273a94b200305c/Coursera-1-.jpg'
            );
        },
    },
    mounted() {
        const sortCategories = (cats: CourseraCategory[]) =>
            cats
                .map(cat => ({
                    id: cat.id,
                    name: cat.name,
                    subCategories: cat.subCategories.sort((a, b) => a.name.localeCompare(b.name)),
                }))
                .sort((a, b) => a.name.localeCompare(b.name));

        CourseraService.getCategories()
            .then(cats => (this.categories = sortCategories(cats)))
            .finally(() => (this.loading = false));
    },
});
